/** One pass for both figures, so a donation adds its amount and its unit in the same frame (TEC-3832). */

export type WindowDonation = { amountCents: number; timestamp: number };

export type ArrivedTotals = {
	raisedEuros: number;
	donationCount: number;
};

/** `now` is `0` on the first render so server and browser both produce the baseline; anything else is a #418. */
export function arrivedTotals(
	baseline: { totalAtWindowStartCents: number; totalAtWindowStartCount: number },
	donations: readonly WindowDonation[],
	now: number,
): ArrivedTotals {
	let cents = baseline.totalAtWindowStartCents;
	let count = baseline.totalAtWindowStartCount;

	for (const donation of donations) {
		if (donation.timestamp > now) continue;
		cents += donation.amountCents;
		count += 1;
	}

	return { raisedEuros: cents / 100, donationCount: count };
}
